import { ReactNode } from 'react';

import { StyledReactTooltip } from './Form.styled';

interface FormInputHelpProps {
  dataKey: string;
  children?: ReactNode;
}

export const FormInputHelp = ({ dataKey, children }: FormInputHelpProps) => (
  <StyledReactTooltip
    effect="solid"
    id={`help-${dataKey}`}
    place="right"
    // if we don't do this, it generates a new class name every time which makes the storyshots test fail every time.
    // if this turn out to be a problem, just remove the `uuid` prop and add `_NOSHOTS` postfix to the name of the stories.
    uuid={`style-${dataKey}`}
  >
    {children}
  </StyledReactTooltip>
);

FormInputHelp.displayName = 'FormInputHelp';
